import React, { Component } from 'react';
import WhyItMattersCard from './whyitmatterscards/whyitmatterscards';
import whyitmattersImage from '../../images/whyitmatters/whyitmatters.jpg';


class WhyItMatters extends Component {

  render() {
    return (
      <section id="why-it-matters-section">
        <div className="container">
          <div className="row whyitmatters-top-flex">
            <div className="firstcol">
              <img src={whyitmattersImage} alt="why it matters"/>
            </div>
            <div className="lastcol">
              <h2>Why It Matters</h2>
              <p>Parents today have a lot on their plates. Juggling the demands of home, work and other responsibilities leaves many parents feeling they do not have enough time with their children. Even small acts of kindness, protection, and caring—a hug, a smile, or loving words—make a big difference to children.</p>
              <p>Research shows kids who receive affection and nurturing from their parents have the best chance of developing into happy, healthy, and competent children, teens, and adults.  A relationship in the early years with a consistent, stable, and caring adult is associated with better academic grades, healthier behaviors, more positive peer interactions, and an increased ability to cope with stress in later life.</p>
              <p className="subscript">* Strengthening Families and Communities 2010 Guide, Department of Health and Human Services</p>
            </div>
          </div>
          <div className="row whyitmatters-bottom-flex">
            <h3>It’s important to remember small actions can have a big impact. When you  build positive relationships with youth under the age of 18, they are less likely to:</h3>
            <div className="row whyitmatters-flex">
                <WhyItMattersCard />
            </div>
            <h5>It's important to strengthen families and help children grow happy.</h5>
          </div>
        </div>
      </section>
    );
  }
}

export default WhyItMatters;


// WEBPACK FOOTER //
// ./src/components/whyitmatters/whyitmatters.js